<header>
    <div class="main">
        <div class="d-flex justify-content-between align-items-center">
            <img class="logo" src="assets/images/logo.png">
            <div>
                <img class="icon icon-notifcation" src="assets/images/notifcation.png">
                <img class="icon icon-email ms-3" src="assets/images/email.png">
                <img class="icon icon-user ms-3" [matMenuTriggerFor]="menu" src="assets/images/user.png">
            </div>
        </div>
    </div>
    <mat-menu #menu="matMenu">
        <button (click)="logout()" mat-menu-item>LogOut</button>
        <button (click)="change_password()" mat-menu-item>Change Password</button>
    </mat-menu>
</header>